import script from "./CustomPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPopover.vue?vue&type=script&setup=true&lang=js"

import "./CustomPopover.vue?vue&type=style&index=0&id=29dc6fd1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dc6fd1"]])

export default __exports__